module.exports = __webpack_public_path__ + "img/text.661c2044.png";